(function() {
    'use strict';

a3_cabin_reports.factory('FlightMealCriteriaFactory', FlightMealCriteriaFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name FlightMealCriteriaFactory
    * @description 
    * Get selected flight info
    * @ngInject
    */ 
function FlightMealCriteriaFactory(GenericService) {
    
    var service = {

        setMealCriteria: setMealCriteria,
        getMealCriteria: getMealCriteria,
        getMealCriteriaByFlightIdFromLS: getMealCriteriaByFlightIdFromLS,
        upsertMealCriteria: upsertMealCriteria,
        cleanOldDataMealCriteria: cleanOldDataMealCriteria
    };

    /**
    * Initialize the MealCriteria 
    * @memberof FlightMealCriteriaFactory
    */
    function MealCriteria() {
        this.Id = null;
        this.LocalSTD = null;
        this.Rotation = null;
        this.MealType = null;
        this.Zone = null;
    }
    var objType = 'mealCriteriaList';
    var objTypeCallback = MealCriteria;

    /**
     * Save Meal Criteria
     * @memberof FlightMealCriteriaFactory
     * @param {Array} mealCriteria
     */
    function setMealCriteria(mealCriteria) {
        GenericService.saveAll(mealCriteria, objType);
    }

    /**
     * Get Meal Criteria
     * @memberof FlightMealCriteriaFactory
     * @returns {Array} MealCriteria
     */
    function getMealCriteria() {
        return GenericService.list(objType, objTypeCallback);
    }

    /**
     * Get Meal Criteria by FlightId from Local Storage
     * @memberof FlightMealCriteriaFactory
     */
    function getMealCriteriaByFlightIdFromLS(flightId) {
        var storedMealCriteria = getMealCriteria();  
        return  storedMealCriteria.filter(x => x.FlightId == flightId);
    }

    function upsertMealCriteria(mealCriteria) {
        var flightIds = mealCriteria.map(x => x.FlightId);
        var storedMealCriteria = getMealCriteria();  
        var otherMealCriteria = storedMealCriteria.filter(x => !flightIds.includes(x.FlightId));
        var mergeMealCriteria = otherMealCriteria.concat(mealCriteria);
        setMealCriteria(mergeMealCriteria);
    }

   /**
    * Clean Old Data Service Events
    * @memberof FlightMealCriteriaFactory
    * @param {Array} responseFlightIds
    */
    function cleanOldDataMealCriteria(responseFlightIds){    
        var storedMealCriteria = getMealCriteria();  
        var previousMealCriteria = storedMealCriteria.filter(x => responseFlightIds.includes(x.FlightId));
        setMealCriteria(previousMealCriteria);
    }

    return service;
}
})();